import { render, staticRenderFns } from "./portal-layout.vue?vue&type=template&id=35727f28&"
import script from "./portal-layout.vue?vue&type=script&lang=js&"
export * from "./portal-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports